//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Creates new Faq entity for the Study.
 * @param layout Schema of the FAQ
 * @param studyId (optional) Id of the study
 */
export function createFaq(layout: { [key: string]: any; }, studyId?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.FaqDto> {
    let url_ = getBaseUrl() + "/api/faq?";
    if (studyId === null)
        throw new Error("The parameter 'studyId' cannot be null.");
    else if (studyId !== undefined)
        url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(layout);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateFaq,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateFaq(_response);
    });
}

function processCreateFaq(response: AxiosResponse): Promise<Types.FaqDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.FaqDto.fromJS(resultData200);
        return Promise.resolve<Types.FaqDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FaqDto>(null as any);
}

/**
 * Update existed Faq
 * @param layout Schema of the FAQ
 * @param id (optional) Id of the FAQ
 */
export function putFaq(layout: { [key: string]: any; }, id?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.FaqDto> {
    let url_ = getBaseUrl() + "/api/faq?";
    if (id === null)
        throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
        url_ += "id=" + encodeURIComponent("" + id) + "&";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(layout);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPutFaq,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPutFaq(_response);
    });
}

function processPutFaq(response: AxiosResponse): Promise<Types.FaqDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.FaqDto.fromJS(resultData200);
        return Promise.resolve<Types.FaqDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FaqDto>(null as any);
}

/**
 * Return entity of the Faq
 * @param id Form Id.
 */
export function getById(id: number, config?: AxiosRequestConfig | undefined): Promise<Types.FaqDto> {
    let url_ = getBaseUrl() + "/api/faq/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetById,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetById(_response);
    });
}

function processGetById(response: AxiosResponse): Promise<Types.FaqDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.FaqDto.fromJS(resultData200);
        return Promise.resolve<Types.FaqDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FaqDto>(null as any);
}
let _requestConfigCreateFaq: Partial<AxiosRequestConfig> | null;
export function getCreateFaqRequestConfig() {
  return _requestConfigCreateFaq;
}
export function setCreateFaqRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateFaq = value;
}
export function patchCreateFaqRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateFaq = patch(_requestConfigCreateFaq ?? {});
}

let _requestConfigPutFaq: Partial<AxiosRequestConfig> | null;
export function getPutFaqRequestConfig() {
  return _requestConfigPutFaq;
}
export function setPutFaqRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPutFaq = value;
}
export function patchPutFaqRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPutFaq = patch(_requestConfigPutFaq ?? {});
}

let _requestConfigGetById: Partial<AxiosRequestConfig> | null;
export function getGetByIdRequestConfig() {
  return _requestConfigGetById;
}
export function setGetByIdRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetById = value;
}
export function patchGetByIdRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetById = patch(_requestConfigGetById ?? {});
}